import { Reducer } from 'redux';
import { CrossSellItemsState, Types } from './types';
import { SortProductsItem } from '../../../services/MVP/models';

export const CROSS_SELL_INITIAL_STATE: CrossSellItemsState = {
  loading: false,
  error: false,
  initialized: false,
  hasActivedSkus: false,
  items: [],
  addedSkus: [],
  addedSkusOrigin: {},
  selectedBusinessPartner: undefined
};

type TCustomAction = {
  type: Types;
  payload: {
    loading?: boolean;
    initialized?: boolean;
    hasActivedSkus?: boolean;
    items?: SortProductsItem[];
    sku?: string;
    screenName?: string;
    selectedBusinessPartner?: string;
  };
};

const reducer: Reducer<CrossSellItemsState, TCustomAction> = (
  state = CROSS_SELL_INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_CROSS_SELL_ITEMS:
      return {
        ...state,
        loading: true,
        error: false,
        initialized: false,
        hasActivedSkus: false,
        items: []
      };
    case Types.LOAD_CROSS_SELL_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        initialized: true,
        hasActivedSkus: action.payload.hasActivedSkus || false,
        items: action.payload.items || [],
        selectedBusinessPartner: action.payload.selectedBusinessPartner
      };
    case Types.LOAD_CROSS_SELL_ITEMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        initialized: true,
        hasActivedSkus: false,
        items: [],
        selectedBusinessPartner: undefined
      };

    case Types.REMOVE_CROSS_SELL_ITEM:
      return {
        ...state,
        items: state.items.filter(
          (item) => String(item.sku) !== String(action.payload.sku)
        )
      };

    case Types.CLEAN_CROSS_SELL_STATE:
      return {
        ...state,
        loading: false,
        error: false,
        initialized: false,
        hasActivedSkus: false,
        items: [],
        addedSkus: [],
        addedSkusOrigin: {},
        selectedBusinessPartner: undefined
      };

    case Types.ADD_CROSS_SELL_SKU: {
      const sku = String(action.payload.sku);
      if (state.addedSkus.includes(sku)) return state;
      return {
        ...state,
        addedSkus: [...state.addedSkus, sku],
        addedSkusOrigin: {
          ...state.addedSkusOrigin,
          [sku]: action.payload.screenName ?? 'revisar_pedido'
        }
      };
    }

    case Types.CLEAN_CROSS_SELL_ITEMS:
      return {
        ...state,
        loading: false,
        error: false,
        initialized: false,
        hasActivedSkus: false,
        items: [],
        selectedBusinessPartner: undefined
      };

    default:
      return state;
  }
};

export default reducer;
